import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import type { ModalPortalProps } from './types'

const defaultWrapperId = 'pintxo-modal-portal-wrapper'

function createWrapperAndAppendToBody(wrapperId: string) {
  const wrapperElement = document.createElement('div')
  wrapperElement.setAttribute('id', wrapperId)
  const coreThemeContainers = document.querySelectorAll('[data-ui-theme="core"]')
  let parentElement
  if (coreThemeContainers.length) {
    parentElement = coreThemeContainers[0]
  } else {
    //eslint-disable-next-line
    console.error('No core theme container found. Modal may not be styled correctly.')
    parentElement = document.body
  }
  parentElement.appendChild(wrapperElement)
  return wrapperElement
}

const ModalPortal = ({ children, wrapperId = defaultWrapperId }: ModalPortalProps) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId)
    let systemCreated = false
    // if element is not found with wrapperId or wrapperId is not provided,
    // create and append to body
    if (!element) {
      systemCreated = true
      element = createWrapperAndAppendToBody(wrapperId)
    }
    setWrapperElement(element)

    return () => {
      // delete the programatically created element
      if (systemCreated && element.parentNode) {
        element.parentNode.removeChild(element)
      }
    }
  }, [wrapperId])

  // wrapperElement state will be null on very first render.
  if (wrapperElement === null) return null

  return createPortal(children, wrapperElement)
}
export default ModalPortal
